"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ORDER_FRAGMENT", {
    enumerable: true,
    get: ()=>ORDER_FRAGMENT
});
const _graphqlRequest = require("graphql-request");
const ORDER_FRAGMENT = (0, _graphqlRequest.gql)`
    fragment terpeneFragment on Terpene {
        aliasList
        aromas
        description
        effects
        id
        name
        potentialHealthBenefits
        unitSymbol
    }

    fragment activeTerpeneFragment on ActiveTerpene {
        id
        terpene {
            ...terpeneFragment
        }
        name
        terpeneId
        unit
        unitSymbol
        value
    }

    fragment activeCannabinoidFragment on ActiveCannabinoid {
        cannabinoidId
        cannabinoid {
            description
            id
            name
        }
        unit
        value
    }

    fragment productFragment on Product {
        brand {
            description
            id
            imageUrl
            name
        }
        category
        description
        descriptionHtml
        effects
        enterpriseProductId
        id
        productBatchId
        image
        images {
            id
            url
            label
            description
        }
        menuTypes
        name
        slug
        posId
        potencyCbd {
            formatted
            range
            unit
        }
        potencyThc {
            formatted
            range
            unit
        }
        posMetaData {
            id
            category
            sku
        }
        staffPick
        strainType
        subcategory
        tags
        variants {
            id
            option
            priceMed
            priceRec
            specialPriceMed
            specialPriceRec
            quantity
        }
        terpenes {
            ...activeTerpeneFragment
        }
        cannabinoids {
            ...activeCannabinoidFragment
        }
    }

    fragment customerFragment on Customer {
        birthdate
        email
        guest
        id
        medicalCard {
            expirationDate
            number
            photo
            state
        }
        name
        optIns {
            marketing
            orderStatus
            specials
        }
        phone
    }

    fragment orderFragment on Order {
        createdAt
        customer {
            ...customerFragment
        }
        customerId
        delivery
        dispensaryName
        foreignId
        id
        items {
            option
            price
            product {
                ...productFragment
            }
            productId
            quantity
            subtotal
        }
        medical
        metadata
        orderNumber
        paymentMethod
        pickup
        recreational
        reservationDate {
            startTime
            endTime
        }
        status
        subtotal
        taxes {
            total
        }
        fees {
            total
        }
        discounts {
            total
        }
        total
    }
`;
